import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BalrogadminSharedModule } from '../../shared';
import {
    GroupService,
    GroupPopupService,
    GroupComponent,
    GroupDetailComponent,
    GroupDialogComponent,
    GroupPopupComponent,
    GroupDeletePopupComponent,
    GroupDeleteDialogComponent,
    groupRoute,
    groupPopupRoute,
    GroupResolvePagingParams,
} from './';

const ENTITY_STATES = [
    ...groupRoute,
    ...groupPopupRoute,
];

@NgModule({
    imports: [
        BalrogadminSharedModule,
        RouterModule.forChild(ENTITY_STATES)
    ],
    declarations: [
        GroupComponent,
        GroupDetailComponent,
        GroupDialogComponent,
        GroupDeleteDialogComponent,
        GroupPopupComponent,
        GroupDeletePopupComponent,
    ],
    entryComponents: [
        GroupComponent,
        GroupDialogComponent,
        GroupPopupComponent,
        GroupDeleteDialogComponent,
        GroupDeletePopupComponent,
    ],
    providers: [
        GroupService,
        GroupPopupService,
        GroupResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BalrogadminGroupModule {}
